import { gql, useQuery } from '@apollo/client'
import { RouteComponentProps } from '@reach/router'
import { DashboardTitle } from 'components/Dashboard/DashboardTitleContext'
import { Link } from 'gatsby'
import { flatten, uniq } from 'lodash'
import { Day2And8SalesCountsQuery } from './__generated__/Day2And8SalesCountsQuery'

const day2and8salesCountsQuery = gql`
  query Day2And8SalesCountsQuery {
    phe {
      day2and8salesCounts {
        id
        date
        count
        redCount
        amberCount
        greenCount
        raw
      }
    }
  }
`

const Day2And8SalesCounts = (props: RouteComponentProps) => {
  const { loading, error, data } = useQuery<Day2And8SalesCountsQuery>(day2and8salesCountsQuery)

  if (loading) return <p>Loading...</p>
  if (error) throw error

  const nonLegacyKeys = uniq(flatten(data.phe.day2and8salesCounts.map((x) => Object.keys(x.raw)))).filter((k) => {
    return k.split('-').length === 3
  })

  return (
    <>
      <DashboardTitle title="Day 2 & 8 Sales Counts | PHE" />

      <nav className="breadcrumb ml-6" aria-label="breadcrumbs">
        <ul>
          <li>
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li>
            <a href="/dashboard">Integrations</a>
          </li>
          <li>
            <a href={`/dashboard/phe`}>PHE</a>
          </li>
          <li className="is-active">
            <a href={`/dashboard/phe/day2and8salescounts`} aria-current="page">
              Day 2 & 8 Sales Counts
            </a>
          </li>
        </ul>
      </nav>

      <section className="section is-small">
        <div className="container">
          <h1 className="title">Day 2 & 8 Sales Counts</h1>

          <table className="table is-bordered">
            <thead>
              <th>Date</th>
              {nonLegacyKeys.map((k) => {
                const [, color, sku] = k.split('-')

                return (
                  <th key={k}>
                    {color} - {sku}
                  </th>
                )
              })}
              <th className="has-text-grey-light">Red Count (old)</th>
              <th className="has-text-grey-light">Amber Count (old)</th>
              <th className="has-text-grey-light">Green Count (old)</th>
            </thead>
            <tbody>
              {data.phe.day2and8salesCounts.map((count) => (
                <tr key={count.id}>
                  <td>{count.date}</td>
                  {nonLegacyKeys.map((k) => (
                    <td key={k}>{count.raw[k]}</td>
                  ))}
                  <td>{count.redCount}</td>
                  <td>{count.amberCount}</td>
                  <td>{count.greenCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  )
}

export default Day2And8SalesCounts
